export default "__VITE_ASSET__D$nzQyrJ__"